import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CpMarketplaceApiService } from 'appRootPath/services/cp-marketplace-api.service';
import { ToastrService } from 'ngx-toastr';
import { CpSigningUrlsService } from 'appRootPath/services/cp-signing-urls.service';
import { ONLY_ESIGN, DOCUMENT_NAME_MAP } from 'appRootPath/shared/global-meta-data';

@Component({
  selector: 'app-simple-signing-modal',
  templateUrl: './simple-signing-modal.component.html',
  styleUrls: ['./simple-signing-modal.component.scss']
})
export class SimpleSigningModalComponent implements OnInit {
  signDocumentsForm: FormGroup;
  @Input() modalInputs = {
    listingId: null,
    signatoriesList: [],
    documents: []
  };
  documentNamesMap = DOCUMENT_NAME_MAP;

  onlyEsign = ONLY_ESIGN;


  constructor(
    public activeModal: NgbActiveModal,
    private apiService: CpMarketplaceApiService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private signingService: CpSigningUrlsService) { }

  ngOnInit() {
    this.signDocumentsForm = this.formBuilder.group({
      sign_documents: this.makeSigningForm(this.modalInputs.documents)
    });
  }

  makeSigningForm(documents) {
    return this.formBuilder.array(documents.map((doc) => {
      return this.formBuilder.group({
        document_name: [doc.name],
        signing_option: [this.onlyEsign],
        selectedSignatories: [null]
      });
    }));
  }

  /**
* Handler for the remove selected signatory action of the ngselect control
* @param docIdx the document index in the perdocsignatory form array
* @param signatoryId the signatory to remove form the doc signatory list
*/
  removeDocSignatory(docIdx, signatoryId) {
    const docSignatories =
      (<FormArray>this.signDocumentsForm.get('sign_documents')).at(docIdx).get('selectedSignatories');
    docSignatories.patchValue(docSignatories.value.filter(value => value.id !== signatoryId));
  }

  postSignedDocuments() {
    if (!this.signDocumentsForm.value.sign_documents.every(doc => doc.selectedSignatories && doc.selectedSignatories.length)) {
      this.toastr.warning('Signatories must be added for all documents to proceed.');
      return;
    }
    const formData = {
      signatories: {},
      documents: []
    };
    this.signDocumentsForm.value.sign_documents.forEach((doc) => {
      formData.signatories[doc.document_name] = doc.selectedSignatories;
      formData.documents.push(doc.document_name);
    });
    this.apiService.sendListingForSign(this.modalInputs.listingId, formData)
      .subscribe((apiResp: any) => {
        if (!apiResp.error) {
          if (apiResp.signing_details) {
            this.signingService.setUrls(apiResp.signing_details);
          }
          this.activeModal.close(true);
          this.toastr.success('Listing documents have been e-mailed to the selected signatories for signing.');
        }
      });
  }

}
